module.exports = __webpack_public_path__ + "ad1bfa5fac6d4e9572648da342481344.png";